import axios from "axios";
import { GET_ALL_NEW_NOTIFICATION_SUCCESS, GET_ALL_NOTIFICATION, GET_ALL_NOTIFICATION_FAILED, GET_ARCHIVE_NOTIFICATION_SUCCESS, NOTIFICATION_DELETE, NOTIFICATION_STATUS_ARCHIVE_UPDATE, NOTIFICATION_STATUS_UN_ARCHIVE_UPDATE, NOTIFICATION_STATUS_UPDATE } from "../../constants/notificationConstant";
import ToastManager from "../../../modules/default/popup/alert/apiNotification";
import { useNavigate } from "react-router-dom";

export  const notificationAction = (page=1, status) => async(dispatch) => {
        dispatch({type: GET_ALL_NOTIFICATION});
        try {
            const res = await axios.get(`/notification?limit=8&page=${page}&status=${status}`);
            dispatch({ 
                type: status === "new" ? "GET_ALL_NEW_NOTIFICATION_SUCCESS" : status === "archive" ? "GET_ARCHIVE_NOTIFICATION_SUCCESS" : "GET_ALL_NOTIFICATION_SUCCESS", 
                payload: {
                    data: res.data.data,
                    pagination: res.data.pagination,
                    unread: res.data.unread,
                    page: page 
                }
            });

        } catch(error) {
            dispatch({type: GET_ALL_NOTIFICATION_FAILED, payload: error.message});
        }
}

export  const notificationStatusUpdateAction = (id) => async(dispatch) => {
        try {
            const res = await axios.put(`/notification/unread`, {'id' : id});
            dispatch({ 
                type: NOTIFICATION_STATUS_UPDATE, 
                payload: {
                    id: id,
                    status: 'read' 
                }
            });

        } catch(error) {
            dispatch({type: GET_ALL_NOTIFICATION_FAILED, payload: error.message});
        }
}
export  const markAllNotificationsAsRead = () => async(dispatch) => {
        const toastId = ToastManager.showLoading('Processing...');
        try {
            const res = await axios.put(`/notification/unread`);
            if(res.status >= 200 && res.status < 300){
                ToastManager.showSuccess(toastId, res.data.message || 'Mark all read successfully!');
                dispatch(notificationAction(1, ""));
                dispatch(notificationAction(1, "new"));
               
            }

        } catch(error) {
            dispatch({type: GET_ALL_NOTIFICATION_FAILED, payload: error.message});
        }
}
export  const notificationStatusArchiveAction = (id) => async(dispatch) => {
    const toastId = ToastManager.showLoading('Processing...');
    try {
        const response = await axios.put(`/notification/archive`, {'id': id});
        if(response.status >= 200 && response.status < 300){
            ToastManager.showSuccess(toastId, response.data.message || 'Notification archived successfully!');
            dispatch({ 
                type: NOTIFICATION_STATUS_ARCHIVE_UPDATE, 
                payload: {
                    id: id,
                    data: response.data.data 
                }
            });
            return response;
        }

    } catch(error) {
        dispatch({type: GET_ALL_NOTIFICATION_FAILED, payload: error.message});
        ToastManager.showError(toastId, error.message || 'Failed to archived notification.');
    }
}
export  const notificationStatusUnArchiveAction = (id) => async(dispatch) => {
    const toastId = ToastManager.showLoading('Processing...');
    try {
        const response = await axios.put(`/notification/archive`, {
            'id': id,
            'archived': false
        });
        if(response.status >= 200 && response.status < 300){
            ToastManager.showSuccess(toastId, response.data.message || 'Notification archived successfully!');
            dispatch({ 
                type: NOTIFICATION_STATUS_UN_ARCHIVE_UPDATE, 
                payload: {
                    id: id,
                    data: response.data.data 
                }
            });
            return response;
        }

    } catch(error) {
        dispatch({type: GET_ALL_NOTIFICATION_FAILED, payload: error.message});
        ToastManager.showError(toastId, error.message || 'Failed to archived notification.');
    }
}
export  const notificationDeleteAction = (id) => async(dispatch) => {
    const toastId = ToastManager.showLoading('Processing...');
    try {
        const response = await axios.delete(`/notification`, {
            data:{ id: id}
        });
        if(response.status >= 200 && response.status < 300){
            ToastManager.showSuccess(toastId, response.data.message || 'Notification archived successfully!');
            dispatch({ 
                type: NOTIFICATION_DELETE, 
                payload: {
                    id: id
                }
            });
            return response;
        }

    } catch(error) {
        dispatch({type: GET_ALL_NOTIFICATION_FAILED, payload: error.message});
        ToastManager.showError(toastId, error.message || 'Failed to archived notification.');
    }
}

